import { useTranslation } from 'react-i18next';

export const usePageTooltips = () => {
  const { t } = useTranslation();

  return {
    collaborators: `${t('tooltip.collaborators.title')}
  
${t('tooltip.collaborators.required')}
${t('tooltip.collaborators.required.items.name')}
${t('tooltip.collaborators.required.items.weeklyWorkload')}
${t('tooltip.collaborators.required.items.dailyWorkload')}
${t('tooltip.collaborators.required.items.atRoster')}
${t('tooltip.collaborators.required.items.order')}
${t('tooltip.collaborators.required.items.team')}
  
${t('tooltip.collaborators.instructions.title')}
${t('tooltip.collaborators.instructions.step1')}
${t('tooltip.collaborators.instructions.step2')}
${t('tooltip.collaborators.instructions.step3')}
${t('tooltip.collaborators.instructions.step4')}`,
  
    general: `${t('tooltip.general.title')}
  
${t('tooltip.general.required')}
${t('tooltip.general.required.items.weeks')}
${t('tooltip.general.required.items.days')}
${t('tooltip.general.required.items.cycle')}
${t('tooltip.general.required.items.offset')}
${t('tooltip.general.required.items.ga')}
${t('tooltip.general.required.items.offsum')}
  
${t('tooltip.general.instructions.title')}
${t('tooltip.general.instructions.step1')}
${t('tooltip.general.instructions.step2')}
${t('tooltip.general.instructions.step3')}`,

    schedule: `${t('tooltip.schedule.title')}
  
${t('tooltip.schedule.components.title')}
${t('tooltip.schedule.components.times.title')}
${t('tooltip.schedule.components.times.start_end')}
${t('tooltip.schedule.components.times.meal')}
     
${t('tooltip.schedule.components.shifts.title')}
${t('tooltip.schedule.components.shifts.morning')}
${t('tooltip.schedule.components.shifts.afternoon')}
${t('tooltip.schedule.components.shifts.night')}
${t('tooltip.schedule.components.shifts.off')}
  
${t('tooltip.schedule.components.properties.title')}
${t('tooltip.schedule.components.properties.code')}
${t('tooltip.schedule.components.properties.legend')}
${t('tooltip.schedule.components.properties.description')}
${t('tooltip.schedule.components.properties.weight')}
  
${t('tooltip.schedule.instructions.title')}
${t('tooltip.schedule.instructions.step1')}
${t('tooltip.schedule.instructions.step2')}`,

    shiftRestrictions: `${t('tooltip.shiftRestriction.title')}

${t('tooltip.shiftRestriction.instructions.title')}
${t('tooltip.shiftRestriction.instructions.step1')}
${t('tooltip.shiftRestriction.instructions.step2')}
${t('tooltip.shiftRestriction.instructions.step3')}
${t('tooltip.shiftRestriction.instructions.step4')}
    `,

    transitions: `${t('tooltip.transitions')}`,

    staffRequirement: `${t('tooltip.staffRequirement.title')}
  
${t('tooltip.staffRequirement.required')}
${t('tooltip.staffRequirement.items.days')}
${t('tooltip.staffRequirement.items.demand')}
  
${t('tooltip.staffRequirement.instructions.title')}
${t('tooltip.staffRequirement.instructions.step1')}
${t('tooltip.staffRequirement.instructions.step2')}
${t('tooltip.staffRequirement.instructions.step3')}`,

    staffDistribution: `${t('tooltip.staffDistribution.title')}
  
${t('tooltip.staffDistribution.configure.title')}
${t('tooltip.staffDistribution.configure.distribution')}
${t('tooltip.staffDistribution.configure.requirements')}
${t('tooltip.staffDistribution.configure.breaks')}
  
${t('tooltip.staffDistribution.instructions.title')}
${t('tooltip.staffDistribution.instructions.step1')}
${t('tooltip.staffDistribution.instructions.step2')}
${t('tooltip.staffDistribution.instructions.step3')}
${t('tooltip.staffDistribution.instructions.step4')}`,

    shiftSequence: `${t('tooltip.shiftSequence.title')}
  
${t('tooltip.shiftSequence.define.title')}
${t('tooltip.shiftSequence.define.hard')}
${t('tooltip.shiftSequence.define.soft')}
${t('tooltip.shiftSequence.define.penalties')}
  
${t('tooltip.shiftSequence.instructions.title')}
${t('tooltip.shiftSequence.instructions.step1')}
${t('tooltip.shiftSequence.instructions.step2')}
${t('tooltip.shiftSequence.instructions.step3')}
${t('tooltip.shiftSequence.instructions.step4')}`,

    weeklySum: `${t('tooltip.weeklySum.title')}
  
${t('tooltip.weeklySum.configure.title')}
${t('tooltip.weeklySum.configure.limits')}
${t('tooltip.weeklySum.configure.penalties')}
${t('tooltip.weeklySum.configure.balance')}
  
${t('tooltip.weeklySum.instructions.title')}
${t('tooltip.weeklySum.instructions.step1')}
${t('tooltip.weeklySum.instructions.step2')}
${t('tooltip.weeklySum.instructions.step3')}`,

    result: `${t('tooltip.result.title')}
  
${t('tooltip.result.displays.title')}
${t('tooltip.result.displays.schedule')}
${t('tooltip.result.displays.assignments')}
${t('tooltip.result.displays.distribution')}
${t('tooltip.result.displays.stats')}
  
${t('tooltip.result.navigation.title')}
${t('tooltip.result.navigation.weeks')}
${t('tooltip.result.navigation.shifts')}
${t('tooltip.result.navigation.stats')}`
  };
};